module.exports = __webpack_public_path__ + "img/location.7fe49bcf.svg";